import React from 'react';
import {Typography} from "@mui/joy";

const RequiredIndicator = () => <Typography component="span" color="danger" style={{verticalAlign: 'super'}}>*</Typography>;

export default RequiredIndicator;
